<div class="row" style="--bs-gutter-x: 0">
  <div class="col-md-2"></div>
  <div class="col-md-8">
    <ng-container *ngIf="languageService.selectedLanguage === 'en'; else privacyPolicyNotEn">
      <h2>Privacy Policy</h2><br>
      Last updated: 23 July 2026.<br>
      <br>
      The data controller is:<br>
      <b>Sibrica</b><br>
      ul. Mieczykowa 7/16, 30-389 Krakow, Poland<br>
      e-mail: <a href="mailto:privacy@sibrica.com">privacy@sibrica.com</a><br>
      <br>
      <br>

      <b>1. Scope and purposes of data processing</b><br>
      Personal data may be processed for the purpose of:<br>
      - handling enquiries submitted by contact form, e-mail or phone,<br>
      - preparing and delivering IT services,<br>
      - maintaining website security and preventing abuse,<br>
      - analyzing traffic and improving the quality of the website, subject to analytics consent.<br>

      <br>
      <b>2. Legal bases</b><br>
      Data is processed under Article 6(1)(a), (b) and (f) of the GDPR, namely on the basis of consent, for the performance of a contract, or for the legitimate interests of the controller.<br>

      <br>
      <b>3. Data recipients</b><br>
      Data may be shared with entities supporting IT infrastructure and hosting only to the extent necessary to fulfill the processing purposes.<br>

      <br>
      <b>4. Retention period</b><br>
      Data is stored for the period necessary to fulfill the processing purpose, and afterwards for the period required by law or until limitation periods for claims expire.<br>

      <br>
      <b>5. Data subject rights</b><br>
      You have the right to access, rectify, erase, restrict processing, object, and lodge a complaint with the President of the Personal Data Protection Office.<br>

      <br>
      <b>6. Cookies and similar technologies</b><br>
      The website uses cookies necessary for the website to function and, subject to consent, analytics cookies.<br>
      For traffic analysis we use Google Analytics (Google Ireland Ltd.). As a result, data may be transferred outside the European Economic Area (EEA) on the basis of the safeguards provided for in the GDPR.<br>
      You can change your analytics decision using the Cookie settings button available on the website.<br>

      <br>
      <b>7. Contact</b><br>
      For matters related to personal data protection, please contact us at: <a href="mailto:privacy@sibrica.com">privacy@sibrica.com</a>.<br>

      <br>
      Detailed GDPR information is available on the <a routerLink="/rodo">GDPR</a> page.<br>
      <br>
    </ng-container>

    <ng-template #privacyPolicyNotEn>
    <ng-container *ngIf="languageService.selectedLanguage === 'de'; else privacyPolicyPl">
    <h2>Datenschutzerklärung</h2><br>
    Zuletzt aktualisiert: 23. Juli 2026.<br>
    <br>
    Verantwortlicher für die Datenverarbeitung ist:<br>
    <b>Sibrica</b><br>
    ul. Mieczykowa 7/16, 30-389 Krakau, Polen<br>
    E-Mail: <a href="mailto:privacy@sibrica.com">privacy@sibrica.com</a><br>
    <br>
    <br>

    <b>1. Umfang und Zwecke der Datenverarbeitung</b><br>
    Personenbezogene Daten können zu folgenden Zwecken verarbeitet werden:<br>
    - Bearbeitung von Anfragen über Kontaktformular, E-Mail oder Telefon,<br>
    - Vorbereitung und Erbringung von IT-Dienstleistungen,<br>
    - Aufrechterhaltung der Sicherheit der Website und Verhinderung von Missbrauch,<br>
    - Analyse des Datenverkehrs und Verbesserung der Qualität der Website, vorbehaltlich der Einwilligung in die Analyse.<br>

    <br>
    <b>2. Rechtsgrundlagen</b><br>
    Die Daten werden gemäß Art. 6 Abs. 1 lit. a, b und f DSGVO verarbeitet, d. h. auf Grundlage der Einwilligung, zur Erfüllung eines Vertrags oder aufgrund berechtigter Interessen des Verantwortlichen.<br>

    <br>
    <b>3. Empfänger der Daten</b><br>
    Die Daten können an Stellen weitergegeben werden, die die IT-Infrastruktur und das Hosting unterstützen, und zwar nur in dem Umfang, der zur Erfüllung der Verarbeitungszwecke erforderlich ist.<br>

    <br>
    <b>4. Speicherdauer</b><br>
    Die Daten werden für den zur Erfüllung des Verarbeitungszwecks erforderlichen Zeitraum gespeichert und anschließend für den gesetzlich vorgeschriebenen Zeitraum oder bis zum Ablauf der Verjährungsfristen für Ansprüche.<br>

    <br>
    <b>5. Rechte der betroffenen Person</b><br>
    Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Widerspruch sowie das Recht, eine Beschwerde beim Präsidenten des Amtes für den Schutz personenbezogener Daten (UODO) einzureichen.<br>

    <br>
    <b>6. Cookies und ähnliche Technologien</b><br>
    Die Website verwendet für den Betrieb notwendige Cookies und, vorbehaltlich der Einwilligung, Analyse-Cookies.<br>
    Zur Verkehrsanalyse verwenden wir Google Analytics (Google Ireland Ltd.). Dadurch können Daten auf Grundlage der in der DSGVO vorgesehenen Garantien außerhalb des Europäischen Wirtschaftsraums (EWR) übermittelt werden.<br>
    Ihre Entscheidung zur Analyse können Sie über die Schaltfläche „Cookie-Einstellungen” auf der Website ändern.<br>

    <br>
    <b>7. Kontakt</b><br>
    In Angelegenheiten des Schutzes personenbezogener Daten kontaktieren Sie uns bitte unter: <a href="mailto:privacy@sibrica.com">privacy@sibrica.com</a>.<br>

    <br>
    Ausführliche DSGVO-Informationen finden Sie auf der Seite <a routerLink="/rodo">DSGVO</a>.<br>
    <br>
    </ng-container>

    <ng-template #privacyPolicyPl>
    <h2>Polityka prywatności</h2><br>
    Ostatnia aktualizacja: 23 lipca 2026 r.<br>
    <br>
    Administratorem danych osobowych jest:<br>
    <b>Sibrica</b><br>
    ul. Mieczykowa 7/16, 30-389 Kraków<br>
    e-mail: <a href="mailto:privacy@sibrica.com">privacy@sibrica.com</a><br>
    <br>
    <br>

    <b>1. Zakres i cele przetwarzania danych</b><br>
    Dane osobowe przetwarzamy w celu:<br>
    - obsługi zapytań kierowanych przez formularz, e-mail lub telefon,<br>
    - przygotowania i realizacji usług informatycznych,<br>
    - utrzymania bezpieczeństwa serwisu i zapobiegania nadużyciom,<br>
    - analizy ruchu i poprawy jakości strony internetowej (po uzyskaniu zgody na analitykę).<br>

    <br>
    <b>2. Podstawy prawne</b><br>
    Dane przetwarzane są zgodnie z art. 6 ust. 1 lit. a, b oraz f RODO, tj. na podstawie zgody, w celu wykonania umowy lub prawnie uzasadnionego interesu administratora.<br>

    <br>
    <b>3. Odbiorcy danych</b><br>
    Dane mogą być przekazywane podmiotom wspierającym utrzymanie infrastruktury IT i hostingu wyłącznie w zakresie niezbędnym do realizacji celów przetwarzania.<br>

    <br>
    <b>4. Okres przechowywania</b><br>
    Dane przechowujemy przez czas niezbędny do realizacji celu przetwarzania, a następnie przez okres wymagany przepisami lub do czasu przedawnienia roszczeń.<br>

    <br>
    <b>5. Prawa osoby, której dane dotyczą</b><br>
    Masz prawo do: dostępu do danych, sprostowania, usunięcia, ograniczenia przetwarzania, sprzeciwu oraz wniesienia skargi do Prezesa UODO.<br>

    <br>
    <b>6. Cookies i technologie podobne</b><br>
    Serwis wykorzystuje pliki cookies niezbędne do działania strony oraz, po wyrażeniu zgody, cookies analityczne.<br>
    Do analizy ruchu wykorzystujemy Google Analytics (Google Ireland Ltd.). W związku z tym dane mogą być przekazywane poza Europejski Obszar Gospodarczy (EOG) na podstawie zabezpieczeń przewidzianych w RODO.<br>
    Decyzję dotyczącą analityki możesz zmienić przez przycisk „Ustawienia cookies” dostępny na stronie.<br>

    <br>
    <b>7. Kontakt</b><br>
    W sprawach związanych z ochroną danych osobowych prosimy o kontakt na adres: <a href="mailto:privacy@sibrica.com">privacy@sibrica.com</a>.<br>

    <br>
    Szczegółową klauzulę informacyjną znajdziesz na stronie <a routerLink="/rodo">RODO</a>.<br>
    <br>
    </ng-template>
    </ng-template>

  </div>
  <div class="col-md-2"></div>
</div>
